document.addEventListener('bundler:total_cart_values', function (e) {
  const {
    total_amount_original = 0,
    total_amount_discounted = 0,
    discount_amount = 0,
    discounted_cart_object = null,
  } = e.detail;

  // Update subtotal display
  const subtotalWithoutTaxElement = document.getElementById('cart-price_subtotal');
  const subtotalWithTax = (total_amount_discounted / 100).toFixed(2).replace('.', ',');
  if (subtotalWithoutTaxElement) {
    subtotalWithoutTaxElement.textContent = `€${subtotalWithTax}`;
  }

  // Calculate and track all discounts
  let totalDiscount = discount_amount;
  let compareAtDiscounts = 0;
  let promises = [];

  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item) => {
      const itemElement = document.querySelector(`[data-cart-variant="${item.variant_id}"]`);

      // Fetch full product info to get accurate compare_at_price
      const promise = fetch(`/products/${item.handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const variant =
            product.variants.find((v) => v.id == item.variant_id) ||
            product.variants.find((v) => v.title == item.variant_title);

          if (!variant) return;

          // Calculate compare_at_price discount if it exists
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const itemDiscount = (variant.compare_at_price - variant.price) * item.quantity;
            compareAtDiscounts += itemDiscount;

            // Update display for this item
            if (itemElement) {
              const oldPriceElements = itemElement.querySelectorAll('[data-old-price]');
              oldPriceElements.forEach((oldPriceEl) => {
                if (oldPriceEl) {
                  oldPriceEl.textContent = `€${((variant.compare_at_price * item.quantity) / 100)
                    .toFixed(2)
                    .replace('.', ',')}`;
                  oldPriceEl.style.display = 'block';
                }
              });

              const newPriceElements = itemElement.querySelectorAll('[data-new-price]');
              newPriceElements.forEach((newPriceEl) => {
                if (newPriceEl) {
                  newPriceEl.textContent = `€${(item.line_price / 100).toFixed(2).replace('.', ',')}`;
                }
              });
            }
          } else if (itemElement) {
            // Hide old price if there's no compare_at_price discount
            const oldPriceElements = itemElement.querySelectorAll('[data-old-price]');
            oldPriceElements.forEach((oldPriceEl) => {
              if (oldPriceEl) {
                oldPriceEl.style.display = 'none';
              }
            });
          }
        })
        .catch((error) => {
          console.error(`Error fetching product data for ${item.handle}:`, error);
        });

      promises.push(promise);
    });
  }

  // Update all prices after all fetch requests complete
  Promise.all(promises).then(() => {
    // Combine all discount types
    const combinedDiscount = totalDiscount + compareAtDiscounts;

    // Update total discount display
    const totalDiscountElement = document.getElementById('cart-price_discount');
    if (totalDiscountElement && combinedDiscount > 0) {
      const formattedDiscount = (combinedDiscount / 100).toFixed(2).replace('.', ',');
      totalDiscountElement.textContent = `€-${formattedDiscount}`;

      // Show discount row
      document.querySelectorAll('[data-cart-discount]').forEach((el) => {
        el.classList.add('flex');
        el.classList.remove('hidden');
      });
    } else {
      // Hide discount row if no discounts
      document.querySelectorAll('[data-cart-discount]').forEach((el) => {
        el.classList.remove('flex');
        el.classList.add('hidden');
      });
    }
  });

  // Update the total price display
  const totalPriceElement = document.getElementById('cart-price_total');
  const totalPrice = (total_amount_discounted / 100).toFixed(2).replace('.', ',');
  if (totalPriceElement) {
    totalPriceElement.textContent = `€${totalPrice}`;
  }

  // USING YOUR ORIGINAL SHIPPING THRESHOLD LOGIC
  const shippingThreshold = 100; // 100 euros
  const currentTotal = total_amount_discounted / 100; // Convert cents to euros
  const progressBarElement = document.getElementById('shipping-progress-bar');
  const shippingMessageElement = document.getElementById('shipping-message');
  const shippingCostElement = document.getElementById('cart-shipping_amount');
  const shippingCosts = document.getElementById('shipping-costs');
  const shippingCostElementContainer = document.getElementById('cart-shipping_amount-container');

  const checkoutButton = document.querySelector(`.cart__checkout-button`);

  if (progressBarElement) {
    const progressPercentage = Math.min((currentTotal / shippingThreshold) * 100, 100);
    progressBarElement.style.width = `${progressPercentage}%`;
  }

  if (currentTotal < shippingThreshold) {
    const amountLeft = (shippingThreshold - currentTotal).toFixed(2).replace('.', ',');
    shippingMessageElement.innerHTML = `Nog 
        <span id="shipping-threshold-left">
        ${amountLeft}
        </span>
        voor <span class="font-bold text-success" id="shipping-threshold-left">gratis</span> verzending`;
    const shippingThresholdLeftElement = document.getElementById('shipping-threshold-left');
    if (shippingThresholdLeftElement) {
      shippingThresholdLeftElement.textContent = `${amountLeft} €`;
    }
    if (shippingCostElement) {
      shippingCostElementContainer.classList.add('hidden');
      shippingCostElement.textContent = '150,00 €';
    }

    if (shippingCosts) {
      shippingCosts.style.display = 'flex';
    }
  } else {
    shippingMessageElement.innerHTML = `Je hebt <span class="font-bold text-success" id="shipping-threshold-left">gratis</span> verzending`;
    if (shippingCostElement) {
      shippingCostElementContainer.classList.remove('hidden');
      shippingCostElement.textContent = 'Gratis';
    }

    if (shippingCosts) {
      shippingCosts.style.display = 'none';
    }
  }
});

function increaseQuantity(event, id) {
  event.preventDefault();
  console.log('increase quantity', id);

  const quantityInput = document.querySelector(`quantity-input[id="Quantity-${id}"] input`);
  if (quantityInput) {
    const currentValue = parseInt(quantityInput.value) || 0;
    const step = parseInt(quantityInput.step) || 1;
    const max = parseInt(quantityInput.max) || Infinity;
    const newValue = Math.min(currentValue + step, max);

    if (newValue !== currentValue) {
      quantityInput.value = newValue;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

function decreaseQuantity(event, id) {
  event.preventDefault();
  console.log('decrease quantity', id);

  const quantityInput = document.querySelector(`quantity-input[id="Quantity-${id}"] input`);
  if (quantityInput) {
    const currentValue = parseInt(quantityInput.value) || 0;
    const step = parseInt(quantityInput.step) || 1;
    const min = parseInt(quantityInput.min) || 0;
    const newValue = Math.max(currentValue - step, min);

    if (newValue !== currentValue) {
      quantityInput.value = newValue;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
